var _effectorFileName = "/builds/gmini/front-common/src/components/SwitchProject/SwitchProjectItem/SwitchProjectItem.tsx";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { getProjectSourceTypeDesc } from "../getProjectSourceTypeDesc";
import { SwitchProjectGroupName, SwitchProjectPopoverItem, SwitchProjectProjectName } from "./SwitchProjectItem.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SwitchProjectItem = function SwitchProjectItem(_ref) {
  var onChangeProject = _ref.onChangeProject,
      onClose = _ref.onClose,
      project = _ref.project;
  return /*#__PURE__*/_jsxs(SwitchProjectPopoverItem, {
    "data-test-id": "projectSelectItem",
    onClick: function onClick() {
      onChangeProject(project);
      onClose();
    },
    children: [/*#__PURE__*/_jsx(SwitchProjectProjectName, {
      children: project.name
    }), /*#__PURE__*/_jsx(SwitchProjectGroupName, {
      children: getProjectSourceTypeDesc(project.sourceType)
    })]
  });
};